/** Small inline U.S. flag (no image request). */
export const UsFlag = ({ className = "h-3 w-[18px]" }) => (
  <svg viewBox="0 0 19 10" className={className} aria-hidden="true">
    <rect width="19" height="10" fill="#B22234" />
    {[1, 3, 5, 7, 9].map((y) => <rect key={y} y={(y * 10) / 13} width="19" height={10 / 13} fill="#fff" />)}
    <rect width="7.6" height={(7 * 10) / 13} fill="#3C3B6E" />
    {[[1.3, 1.2], [3.8, 1.2], [6.3, 1.2], [2.5, 2.7], [5, 2.7], [1.3, 4.2], [3.8, 4.2], [6.3, 4.2]].map(([x, y]) => (
      <circle key={`${x}-${y}`} cx={x} cy={y} r="0.45" fill="#fff" />
    ))}
  </svg>
);
